import { Container, Row } from "reactstrap";
import { JobDetails, JobSearch } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import LeftSidebar from "../common/leftSidebar";
import JobDetailsRightCards from "./jobDetailsRightCards";

const JobDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={JobDetails} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <JobDetailsRightCards />
        </Row>
      </Container>
    </>
  );
};
export default JobDetailsContainer;
